module.exports = __webpack_public_path__ + "img/login-online.da2d14f3.jpg";